<app-lacchain></app-lacchain>
<router-outlet></router-outlet>
<simple-notifications></simple-notifications>
